function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//  @jsx h
import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';
import warn from '../../lib/warn';
import Scrubber from './Scrubber';
import TogglePlayButton from './TogglePlayButton';
import ToggleMuteButton from './ToggleMuteButton';
var style = {
  "videoPlayer": "dhfc-1_0_0-beta_48-videoPlayer",
  "videoPlayer__container": "dhfc-1_0_0-beta_48-videoPlayer__container",
  "videoPlayer__caption": "dhfc-1_0_0-beta_48-videoPlayer__caption",
  "videoPlayer__controls": "dhfc-1_0_0-beta_48-videoPlayer__controls",
  "videoPlayer__togglePlayButton": "dhfc-1_0_0-beta_48-videoPlayer__togglePlayButton",
  "videoPlayer__toggleMuteButton": "dhfc-1_0_0-beta_48-videoPlayer__toggleMuteButton"
};

class VideoPlayer extends PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "video", void 0);

    _defineProperty(this, "state", {
      caption: null,
      duration: 0,
      isPlaying: false,
      time: 0
    });

    _defineProperty(this, "handleUserTogglePlay", () => {
      this.props.onUserTogglePlay();
    });

    _defineProperty(this, "handleUserToggleMute", () => {
      this.props.onUserToggleMute();
    });

    _defineProperty(this, "handleScrubberPositionUpdate", position => {
      if (this.video) {
        this.video.seek(this.state.duration * position);
      } else {
        warn('[@nrk/dh-feature-components] No video reference');
      }
    });

    _defineProperty(this, "handleCaptionCueEnter", caption => {
      this.setState({
        caption
      });
    });

    _defineProperty(this, "handleCaptionCueExit", () => {
      this.setState({
        caption: null
      });
    });

    _defineProperty(this, "handleDurationChange", duration => {
      this.setState({
        duration
      });
    });

    _defineProperty(this, "handlePlay", () => {
      const onPlay = this.props.onPlay;
      this.setState({
        isPlaying: true
      });

      if (onPlay) {
        onPlay();
      }
    });

    _defineProperty(this, "handlePause", () => {
      const onPause = this.props.onPause;
      this.setState({
        isPlaying: false
      });

      if (onPause) {
        onPause();
      }
    });

    _defineProperty(this, "handleTimeupdate", time => {
      this.setState({
        time
      });
    });
  }

  render() {
    const _this$props = this.props,
          muted = _this$props.muted,
          playing = _this$props.playing,
          video = _this$props.video;
    const _this$state = this.state,
          caption = _this$state.caption,
          duration = _this$state.duration,
          isPlaying = _this$state.isPlaying,
          time = _this$state.time;

    if (!video.attributes) {
      throw new Error('The `video` property must be a virtual node');
    }

    const className = `${style.videoPlayer}${this.props.className ? ` ${this.props.className}` : ''}`;
    video.attributes.muted = muted;
    video.attributes.playing = playing;
    video.attributes.playsInline = true;

    video.attributes.ref = video => this.video = video;

    video.attributes.onPlay = this.handlePlay;
    video.attributes.onPause = this.handlePause;
    video.attributes.onCaptionCueEnter = this.handleCaptionCueEnter;
    video.attributes.onCaptionCueExit = this.handleCaptionCueExit;
    video.attributes.onDurationChange = this.handleDurationChange;
    video.attributes.onTimeupdate = this.handleTimeupdate;
    return h("div", {
      className: className
    }, h("div", {
      className: style.videoPlayer__container
    }, video, caption && h("div", {
      className: style.videoPlayer__caption,
      "aria-hidden": "true"
    }, caption.text.split('\n').map((text, idx) => h("div", {
      key: String(idx)
    }, h("span", {
      dangerouslySetInnerHTML: {
        __html: text
      }
    })))), h("div", {
      className: style.videoPlayer__controls
    }, h(TogglePlayButton, {
      className: style.videoPlayer__togglePlayButton,
      playing: isPlaying,
      onClick: this.handleUserTogglePlay
    }), h(Scrubber, {
      time: time,
      duration: duration,
      onPositionUpdate: this.handleScrubberPositionUpdate
    }), h(ToggleMuteButton, {
      className: style.videoPlayer__toggleMuteButton,
      muted: muted,
      onClick: this.handleUserToggleMute
    }))));
  }

}

export default VideoPlayer;